import React, { Fragment, useState, useEffect } from "react";
import OwlCarousel from "react-owl-carousel";
import { BsFillStarFill } from "react-icons/bs";
import { NavLink } from "react-router-dom";
const ReviesAll = (props) => {

  const [Id, setId] = useState("review_certified");

  const listenScrollEvent = (event) => {
    if (window.scrollY > 100) {
      return setId("review_certified_view");
    } else {
      return setId("review_certified");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);

    return () => window.removeEventListener("scroll", listenScrollEvent);
  }, []);
  return (
    <Fragment>
      <section className={props.mainclassName} id={Id}>
        <div className="container">
          <span className="sub-text">{props.heading}</span>
          <h2 className="title title2">{props.SubHeading}</h2>

          <OwlCarousel
            className="rs-carousel owl-carousel"
            loop={true}
            margin={10}
            nav={false}
            items={7}
            autoplay={true}
            autoplayHoverPause={true}
            responsive={{
              1: {
                items: 1,
              },

              768: {
                items: 2,
              },
              992: {
                items: 3,
              },
              1199: {
                items: 3,
              },
              1300: {
                items: 3,
              },
            }}
          >
            {props.details.map((value, index) => (
              <div className="testimonial_cover" key={props.id}>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12">
                    <div className="testimonial_wrapper" id={index}>
                      <span className="quote_img ">
                        <img src={value.revireImg} alt="img" />
                      </span>
                      <ul className="star_list">
                        <li>
                          <BsFillStarFill className="ico" />
                          <BsFillStarFill />
                          <BsFillStarFill />
                          <BsFillStarFill />
                          <BsFillStarFill />
                        </li>
                      </ul>
                      <p>{value.clientReview}</p>
                      <h3>{value.clientName}</h3>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </OwlCarousel>
          <NavLink className="study_portfolio_btn mt-3" to="/us/reviews">
                Client Reviews
              </NavLink>
        </div>
      </section>
    </Fragment>
  );
};

export default ReviesAll;
